<input type="file" #photoInput data-cy="hidden-photo-click" class="hidden" />
<div class="container" [class.open-photo-container]="index === photos.length">
  <div
    *ngIf="!photo?.filepath"
    data-cy="add-photo-button"
    (click)="
      showAddText ? handleSquareClicked(cameraActions.addPhoto) : undefined
    "
    class="overlay"
  ></div>
  <ion-spinner *ngIf="photo && !photo?.doneLoading"></ion-spinner>
  <ng-content></ng-content>
  <div *ngIf="showAddText" class="add-photo-container">
    <img src="../../../../assets/icon/camera.svg" class="camera-img" />
    <p class="add-photo-text" data-cy="add-photo-text">
      {{ 'i18n.common.add' | translate }}
    </p>
  </div>
  <div *ngIf="photo?.filepath" class="photo-cell">
    <ion-thumbnail *ngIf="photo" slot="start">
      <ion-img
        *ngIf="
          photo.extension !== 'pdf' &&
          photo.extension !== 'csv' &&
          photo.extension !== 'comma-separated-values'
        "
        [src]="photo.webviewPath"
      ></ion-img>
      <iframe
        *ngIf="photo.extension === 'pdf'"
        [src]="photo?.safeUrl"
        class="iframe-border"
        frameBorder="0"
      ></iframe>
      <ion-icon
        *ngIf="
          photo.extension === 'csv' ||
          photo.extension === 'comma-separated-values'
        "
        name="restaurant"
      >
      </ion-icon>
      <div
        data-cy="delete-photo-button"
        class="delete-banner"
        (click)="handleSquareClicked(cameraActions.deletePhoto)"
      >
        {{ 'i18n.common.delete' | translate }}
      </div>
    </ion-thumbnail>
  </div>
</div>
